import { MapPin, Flag } from "lucide-react";
import { t } from "@/lib/i18n";

export default function LocationFields({ kind, f, setF, meta, inp }) {
  const Icon = kind === "loading" ? MapPin : Flag;
  const country = f[`${kind}_country`];
  const regions = meta.regions?.[country] || [];
  const setCountry = (e) => setF({ ...f, [`${kind}_country`]: e.target.value, [`${kind}_region`]: "" });
  return (
    <div className="hf-card p-6 space-y-4">
      <p className="flex items-center gap-2 font-display font-bold"><Icon className="w-4 h-4 text-amber-600" /> {kind === "loading" ? t("Loading point") : t("Offloading point")}</p>
      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          <label className="hf-label">{t("Country")}</label>
          <select required value={country} onChange={setCountry} className="hf-input" data-testid={`post-load-${kind}_country-select`}>
            <option value="">{t("Select…")}</option>
            {meta.countries.map((c) => <option key={c.name}>{c.name}</option>)}
          </select>
        </div>
        <div>
          <label className="hf-label">{t("Province / region")}</label>
          <select required={regions.length > 0} disabled={!regions.length} value={f[`${kind}_region`]} onChange={(e) => setF({ ...f, [`${kind}_region`]: e.target.value })} className="hf-input disabled:bg-slate-50" data-testid={`post-load-${kind}_region-select`}>
            <option value="">{regions.length ? t("Select…") : t("Not applicable")}</option>
            {regions.map((r) => <option key={r}>{r}</option>)}
          </select>
        </div>
      </div>
      <div><label className="hf-label">{t("Town / area")}</label>{inp(`${kind}_area`, "text", { placeholder: kind === "loading" ? t("e.g. Bethlehem") : t("e.g. Durban") })}</div>
      <div><label className="hf-label">{t("Full address")}</label>{inp(`${kind}_address`)}</div>
    </div>
  );
}
